import { AnchorButton } from "@blueprintjs/core";

export const SignInButton = (props: object) => (
  <AnchorButton
    style={{ lineHeight: "1.15" }}
    intent="primary"
    href={`/login?return_path=${window.location.pathname}`}
    {...props}
  >
    Sign in
  </AnchorButton>
);
